import React, { useEffect } from "react";
import { usePostUpsertApplicationMutation } from "@/store/service";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ApplicationStep } from "@/enum/ApplicationStep";
import Applicants from "@/model/interface/form/Applicants";
import ApplicantEmployment from "./ApplicantEmployment";
import { useApplicantChecks } from "@/components/provider/ApplicantChecksProvider";
import { isDebugForms, getDebugNextStepUrl } from "@/util/debug";
import { applicantsEmploymentSchema } from "@/model/schemas";
import { zodFormResolver } from "@/util/form";

const ApplicantEmploymentWrapper = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { applicant } = useApplicantChecks();
  const [postApplication, postApplicationResult] = usePostUpsertApplicationMutation();

  const form = useForm<Applicants>({
    resolver: zodFormResolver<Applicants>(applicantsEmploymentSchema),
    mode: "onTouched",
    defaultValues: {},
  });
  const { handleSubmit } = form;

  useEffect(() => {
    if (postApplicationResult.isSuccess) {
      navigate(`/application/${postApplicationResult.data.id}/${postApplicationResult.data.step}`);
      return;
    }
  }, [postApplicationResult.isSuccess]);

  const onSubmit = async (data: Applicants) => {
    const applicants = [data.mainApplicant];
    if (data.coApplicant) {
      applicants.push(data.coApplicant);
    }

    await postApplication({ applicants, id: params.id!, step: ApplicationStep.Applicant });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate(getDebugNextStepUrl(params.id!, ApplicationStep.ApplicantEmployment, params.type));
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className="relative">
      <div className="w-full max-w-2xl mx-auto space-y-5">
        <h3 className="text-2xl font-semibold text-gray-900 text-center">Applicant employment</h3>
        <ApplicantEmployment form={form} applicant={applicant} applicantType={"mainApplicant"} />
        <div className="flex justify-center pt-2">
          <button
            type="submit"
            name="submit"
            className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default ApplicantEmploymentWrapper;
